import { render, staticRenderFns } from "./groups_list_item.vue.js?vue&type=template&id=50cb2e8b&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./groups_list_item.vue?vue&type=template&id=50cb2e8b&vue3"
import script from "./groups_list_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./groups_list_item.vue?vue&type=script&lang=js&vue3"
export * from "./groups_list_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./groups_list_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports